export { ProductHeroDecor } from './ProductHeroDecor.brand.generated';
